if (!customElements.get('modal-dialog-popup')) {
  class ModalDialogPopup extends HTMLElement {
    constructor() {
      super();

      this.modalId = this.getAttribute('id');
      this.delay = parseInt(this.dataset.delay, 10) * 1000;
      this.sectionId = this.dataset.sectionId;
      this.disabled = this.hasAttribute('disabled');
      this.moved = false;

      this.cooldownMinutes = 10;
      this.cookieDays = 30;

      this.button = this.querySelector('[id^="ModalClose-"]');
      if (this.button) {
        this.button.addEventListener('click', () => {
          this.setSessionCooldown();
          this.hide();
        });
      }

      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', () => {
          this.setCookieCooldown();

          // Delay hiding modal for 5 seconds after form submission
          setTimeout(() => {
            this.hide();
          }, 5000);
        });
      }

      if (!this.disabled) {
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') {
            this.setSessionCooldown();
            this.hide();
          }
        });
      }

      if (!this.isOnCooldown()) {
        if (this.delay && this.delay > 0) {
          setTimeout(() => this.show(), this.delay);
        } else {
          this.show();
        }
      }

      if (window.Shopify && Shopify.designMode) {
        this.moved = true;
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.sectionId) this.show();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.sectionId) this.hide();
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;

      let container = document.getElementById('modal-container');
      if (!container) {
        container = document.createElement('div');
        container.id = 'modal-container';
        document.body.appendChild(container);
      }
      container.appendChild(this);
    }

    show(opener) {
      const container = document.getElementById('modal-container');
      if (container) container.appendChild(this);

      document.querySelectorAll('modal-dialog[open]').forEach((modal) => {
        if (modal !== this) modal.hide();
      });

      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      setTimeout(() => {
        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) dialog.focus();
      }, 100);
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.pauseMedia();
    }

    pauseMedia() {
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    isOnCooldown() {
      const sessionCooldown = sessionStorage.getItem(`${this.modalId}-cooldown`);
      if (sessionCooldown) return true;

      const cookieName = `${this.modalId}-cookie`;
      const cookie = document.cookie.split(';').find((c) => c.trim().startsWith(cookieName + '='));
      return !!cookie;
    }

    setSessionCooldown() {
      sessionStorage.setItem(`${this.modalId}-cooldown`, 'true');
    }

    setCookieCooldown() {
      const d = new Date();
      d.setTime(d.getTime() + this.cookieDays * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + d.toUTCString();
      document.cookie = `${this.modalId}-cookie=true; ${expires}; path=/`;
    }
  }

  customElements.define('modal-dialog-popup', ModalDialogPopup);
}

if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      if (!button) return;

      button.addEventListener('click', () => {
        const modalSelector = this.getAttribute('data-modal');
        const modal = document.querySelector(modalSelector);
        if (modal) modal.show(button);
      });
    }
  }

  customElements.define('modal-opener', ModalOpener);
}
